import { useDispatch } from "react-redux";
import { showToast, hideToast } from "../features/toast/toastSlice";

const useToast = () => {
  const dispatch = useDispatch();

  const triggerToast = ({
    type = "info",
    primaryMessage = "",
    secondaryMessage = "",
    rightText = "",
    icon = null,
    autoHideDuration = 3000,
  } = {}) => {
    dispatch(
      showToast({ type, primaryMessage, secondaryMessage, rightText, icon, autoHideDuration })
    );
  };

  const dismissToast = () => dispatch(hideToast());

  return { triggerToast, dismissToast };
};

export default useToast;